import React from 'react'

import { formatDuration } from '@disco/utils/time-utils'

import { Text } from 'components/ds'
import { SearchColumnProps } from 'components/search/search-columns/types'

export const DurationColumn = React.memo(({ info }: SearchColumnProps) => {
  return <Text>{formatDuration(info.getValue<number>(), 'mm:ss')}</Text>
})

DurationColumn.displayName = 'DurationColumn'
